export default "__VITE_ASSET__8b2e77f7__"